import React from 'react';
import { Box } from '@mui/material';

const LoadingIpsilum = () => {
  const icon = (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f8f9fa',
        zIndex: 10000,
        position: 'fixed'
      }}
    >
      <Box height="30vh" />
      <center>
        <img
          className="d-inline-block align-top"
          src="/ias-logo/maps.png"
          height="80"
          width="auto"
          alt="logo"
        />
      </center>
    </Box>
  );

  return <Box sx={{ display: 'flex' }}>{icon}</Box>;
};

export default LoadingIpsilum;
